import type {
  ArticleDividerComponent,
  ArticleHeadlineComponent,
  ArticleMediaComponent,
  ArticleParagraphComponent,
  ArticleTableComponent,
  ArticleTextBlockComponent,
  ArticleTextComponent,
  ArticleTooltipComponent,
  ArticleWarningBoxComponent,
} from '@twisto/api-cms'

import type { RichTextBlock } from 'homepage/components/rich-text/rich-text.d'

import { DynamicContent } from '../atoms'
import { Tooltip } from '../atoms/tooltip'
import { RichText } from '../rich-text'

import { Table } from './table'

import { Divider, Headline, Media, Paragraph, Text, WarningBox } from '.'

export type ComponentsType =
  | ArticleDividerComponent
  | ArticleHeadlineComponent
  | (ArticleMediaComponent & { __component?: 'article.media' })
  | (ArticleParagraphComponent & { __component?: 'article.paragraph' })
  | ArticleWarningBoxComponent
  | ArticleTableComponent
  | ArticleTextBlockComponent
  | ArticleTextComponent
  | ArticleTooltipComponent

type Props = {
  components?: ComponentsType[]
}

const ArticleComponent = ({ sectionData }: { sectionData: ComponentsType }) => {
  switch (sectionData.__component) {
    case 'article.divider':
      return <Divider />
    case 'article.headline':
      return <Headline {...sectionData} />
    case 'article.media':
      return <Media {...sectionData} />
    case 'article.paragraph':
      return (
        <Paragraph
          {...sectionData}
          text={sectionData.text as RichTextBlock[]}
        />
      )
    case 'article.warning-box':
      return (
        <WarningBox
          {...sectionData}
          content={sectionData.content as RichTextBlock[]}
        />
      )
    case 'article.table':
      return <Table {...sectionData} />
    case 'article.text-block':
      return <DynamicContent content={sectionData.text} />
    case 'article.text':
      return <Text {...sectionData} />
    case 'article.tooltip':
      return (
        <Tooltip
          {...sectionData}
          content={<RichText input={sectionData.content as RichTextBlock[]} />}
        />
      )
    default:
      return null
  }
}

export const ArticleComponents = ({ components }: Props) => (
  <>
    {components?.map((component, index) => (
      <ArticleComponent
        key={`${component.__component}${index}`}
        sectionData={component}
      />
    ))}
  </>
)
